import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MtDashboardHeaderApiModel } from '@app/api/api-models/program/mentoring/MtDashboardHeaderApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class MtDashboardService {
  public apiUrl = 'mt-dashboard';

  constructor(private readonly http: HttpClientService) {}

  public getHeaderInfo(programRoleId: string): Observable<MtDashboardHeaderApiModel> {
    return this.http.get<MtDashboardHeaderApiModel>(`${this.apiUrl}/${programRoleId}/header-info`);
  }
}
